//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { get, post } from '@api/request';
import { suppAPI } from '@api/modules/supp';
import { debounce } from 'lodash';
export default {
  name: 'SmplEditBomChild',
  props: {
    mdrlForm: {
      type: Object,
      required: true
    },
    isShow: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      mdrlFlag: 0,
      selectFlag: false,
      suppType: []
    };
  },
  created: function created() {
    this.initData();
  },
  methods: {
    initData: function initData() {
      this.getSuppsList();
    },
    // 获取供应商信息
    getSuppsList: function getSuppsList() {
      var _this = this;

      get(suppAPI.getSuppsV1).then(function (res) {
        if (res.data.code === 0) {
          _this.suppType = res.data.data;
        }
      });
    },
    // 修改下拉框
    changegetSuppsList: function changegetSuppsList(val, val1) {
      if (val.mdrl_info_checked) {
        this.$emit('selectChange', val1);
      }
    },
    // 修改价格
    inputChange: debounce(function (val, index) {
      if (val.mdrl_info_checked) {
        this.$emit('inputChange', index);
      }
    }, 500),
    // 删除
    deleteClick: function deleteClick(val) {
      this.$emit('deleteClick', val);
    },
    // 更改复选框
    checkboxChange: function checkboxChange(val, val1) {
      var temp = JSON.parse(JSON.stringify(val));
      this.$emit('checkboxChange', temp, val1);
    }
  }
};